export default __webpack_public_path__ + "static/media/20.5ff1e1c5.svg";